module.exports = __webpack_public_path__ + "img/LC.5a70c335.svg";